import { PlusIcon, UploadIcon, WebhookIcon } from 'lucide-react';
import { useTranslation, Trans } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import { WEBHOOKS_DOCS_URL } from '@/util/constants';

interface NoWebhooksProps {
  onCreate?: () => void;
  onImport?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const NoWebhooks = ({ onCreate, onImport }: NoWebhooksProps) => {
  const { t } = useTranslation();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <WebhookIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{t('webhook.create_webhooks')}</EmptyTitle>
        <EmptyDescription>
          <Trans
            i18nKey="webhook.no_webhooks_description"
            components={{
              docsLink: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content -- Content is dynamically injected by Trans component
                <a
                  className="text-primary underline underline-offset-2 transition-colors"
                  href={WEBHOOKS_DOCS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <div className="flex items-center gap-3">
          {onImport && (
            <Button
              variant="outline-neutral"
              size="sm"
              onClick={() => document.getElementById('webhook-import-input')?.click()}
            >
              <UploadIcon size={16} />
              {t('common.import')}
            </Button>
          )}
          <input
            id="webhook-import-input"
            type="file"
            accept=".json"
            className="hidden"
            onChange={onImport}
          />
          <Button size="sm" onClick={onCreate}>
            <PlusIcon size={16} />
            {t('common.create')}
          </Button>
        </div>
      </EmptyContent>
    </Empty>
  );
};
